import cn from 'classnames'
import { MouseEventHandler, ReactNode, useCallback, useMemo, useState } from 'react'

import { Checkbox } from 'core-components/library/checkbox'

import { ListOfItems } from '../listOfItems/ListOfItems'

import { IconToggle } from './components/iconToggle/IconToggle'
import { ITreeItemProps } from './models/treeItemProps'

import styles from './TreeItem.module.scss'

export const TreeItem = ({
  isSelected,
  isIndeterminate,
  itemId,
  title,
  nestedItems,
  selectedItems,
  onItemSelect,
}: ITreeItemProps) => {
  const [isCollapsed, setCollapsed] = useState(isSelected || isIndeterminate)

  const hasChildren = useMemo(() => nestedItems.length > 0, [nestedItems])

  const handleCollapse = useCallback(() => {
    setCollapsed((prevState) => !prevState)
  }, [])

  const handleItemClick = useCallback(() => {
    onItemSelect(itemId)
  }, [onItemSelect, itemId])

  const handleTitleClick = useCallback<MouseEventHandler<HTMLDivElement>>(() => {
    handleItemClick()
  }, [handleItemClick])

  return (
    <li className={styles.root}>
      <div className={styles.itemContainer}>
        <Checkbox checked={isSelected} indeterminate={isIndeterminate} onChange={handleItemClick} />

        {hasChildren && <IconToggle isCollapsed={isCollapsed} onClick={handleCollapse} />}

        <div className={styles.itemTitle} onClick={handleTitleClick}>
          {title as ReactNode}
        </div>
      </div>
      {nestedItems.length > 0 && (
        <ListOfItems
          items={nestedItems}
          selectedItems={selectedItems}
          className={cn(styles.nestedItems, {
            [styles.isCollapsed]: isCollapsed,
          })}
          onItemSelect={onItemSelect}
        />
      )}
    </li>
  )
}
